import React from "react";


export const Label : React.FC<Props> = (props : Props) : JSX.Element => {

    const label : ILabel = props.label ;
    const classRequired : string = props.isRequired !== undefined ? "required" : ""


    return (
        <label className={classRequired}>
            <span>{label.title}</span>
            {label.subtitle !== undefined ? <p>{label.subtitle}</p> : null}
        </label>
    )  

};


interface Props {
    readonly label : ILabel;
    readonly isRequired : boolean | undefined;
}

export interface ILabel {
    readonly title : string;
    readonly subtitle : string | undefined;
} 